// 导入
import request from '@/utils/request.js'
import qs from 'qs'
// 找UP主模块
// 02.UP主排行数据请求
function Rankone(data) {
	return request.get('/V1/Rank/BloggerRank?' + qs.stringify(data))
}
function RankTwo(data){
	return request.get('/V1/Rank/BloggerRankOption?' + qs.stringify(data))
}
export {
	Rankone,
	RankTwo
}
